if (!document.querySelector('.keyboard')) {
  import('./game.js');
}
